import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const principalSurvivorEmploymentIncomeSelector = (state, props) =>
  whatIfInnerSelector(state, props).PrincipalSurvivorEmploymentIncome;
export const spouseSurvivorEmploymentIncomeSelector = (state, props) =>
  whatIfInnerSelector(state, props).SpouseSurvivorEmploymentIncome;

export const principalNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).PrincipalName;

export const spouseNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const hasSpouseSelector = (state, props) =>
  !!whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const survivorEmploymentIncomeOptionsSelector = (state, props) =>
  (whatIfOptionsOrDefaultSelector(state, props).SurvivorEmploymentIncomeOptions || [])
    .map(percentage => ({
      value: percentage,
      label: `${percentage}% of today's income`,
    }));
